import CarouselBannerBase from './CarouselBannerBase';
function CarouselBanner_1_1_small_rounded({ item }) {
  return (
    <CarouselBannerBase
      item={item}
      imageWidth={33.33}
      aspectRatio={1}
      activeBigger={false}
      isCentered={false}
    ></CarouselBannerBase>
  );
}

export default CarouselBanner_1_1_small_rounded;
